import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useI18n } from "../i18n";
import { getConsent, setConsent } from "../lib/consent";
import { initPostHog } from "../lib/posthog";

export function CookieBanner() {
  const { t } = useI18n();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (getConsent() === "unknown") {
      const id = window.setTimeout(() => setVisible(true), 400);
      return () => window.clearTimeout(id);
    }
  }, []);

  const accept = () => {
    setConsent("accepted");
    initPostHog();
    setVisible(false);
  };
  const decline = () => {
    setConsent("declined");
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 120, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 120, opacity: 0 }}
          transition={{ type: "spring", stiffness: 240, damping: 28 }}
          role="dialog"
          aria-live="polite"
          aria-label={t("cookie.title")}
          className="fixed inset-x-0 bottom-0 z-[60] px-4 pb-4 pointer-events-none"
        >
          <div className="pointer-events-auto max-w-4xl mx-auto rounded-2xl border border-white/50 bg-white/75 backdrop-blur-xl shadow-[0_12px_40px_rgba(0,0,0,0.12)] p-5 md:p-6 flex flex-col md:flex-row gap-4 md:items-center">
            <div className="flex-1 min-w-0">
              <div className="text-sm md:text-base font-medium text-[var(--color-ink)]">
                {t("cookie.title")}
              </div>
              <p className="mt-1 text-xs md:text-sm text-[var(--color-muted)] leading-relaxed">
                {t("cookie.body")}
              </p>
            </div>
            <div className="flex items-center gap-3 md:flex-none flex-wrap">
              <button
                type="button"
                onClick={decline}
                className="pill-outline px-5 py-2 text-sm"
              >
                {t("cookie.decline")}
              </button>
              <button
                type="button"
                onClick={accept}
                className="pill-btn px-5 py-2 text-sm"
              >
                {t("cookie.accept")}
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
